<div class="btn-group hidden-mobile-app" ngbDropdown>
  <button type="button"
          class="btn btn-link"
          ngbDropdownToggle
          [disabled]="isDisabled || !hasData || isLoading">
    @if (!isLoading) {
      <sb-icon name="download"></sb-icon>
      <span>
        {{ (customLabel ? 'SB_Export_All' : 'SB_Export') | translate }}{{ appendText ? ' ' + appendText : '' }}
      </span>
    }
    @if (isLoading) {
      <sb-loading [hasLoaded]="false"></sb-loading>
    }
  </button>
  <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right" id="export-dropdown">
    @for (fileType of fileTypes; track fileType.id) {
      <li>
        <button class="dropdown-item btn btn-link w-100"
                ngbDropdownItem
                (click)="saveFile(fileType.id)">
          <div class="text-muted text-left">
            <sb-icon [name]="fileType.iconName" class="mr-1" [style.color]="fileType.iconColor"></sb-icon>
            {{ fileType.label }}
          </div>
        </button>
      </li>
    }
  </ul>
</div>
